import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './Container';
interface PhraseSeparatorProps {
  phrase: string;
  tone?: 'white' | 'lime';
}
export function PhraseSeparator({
  phrase,
  tone = 'white'
}: PhraseSeparatorProps) {
  return <section className="border-y border-mp-border bg-mp-black py-16 md:py-24" data-id="element-363" data-mp="1e2kpawaarukh">
      <Container data-id="element-364" data-mp="1iwotx8w3bqie">
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className={`text-center font-heading text-2xl uppercase leading-tight tracking-wide sm:text-3xl md:text-5xl ${tone === 'lime' ? 'text-mp-lime' : 'text-mp-white'}`} data-id="element-365" data-mp="1ix6z4v0qdf2g">
          {phrase}
        </motion.p>
      </Container>
    </section>;
}